module.exports = __webpack_public_path__ + "static/app-poster-1a70ec3a3394db3f7e6513abcaa40f16.jpg";